import React from 'react'
import { Link } from 'react-router-dom';

import style from './style.module.scss';

function Tag({tag}) {
  return (
    <>
      <Link to={`/explore?q=${tag}`}>
        <div className={style.tagContainer}>
          {tag}
        </div>
      </Link>
    </>
  )
}

export default Tag